import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';

const ControladorRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Carregando...</div>;
  }

  // Perfil ADMIN = 1, Perfil CONTROLADOR = 2
  return user && (user.perfil_id === 1 || user.perfil_id === 2) ? children : <Navigate to="/dashboard" />;
};

export default ControladorRoute;